import React, { useEffect, useState } from 'react';
import { Card, Avatar, Skeleton, Tag } from 'antd';
import { NotificationOutlined } from '@ant-design/icons';
import api from '../../services/api';
import { absoluteUploadUrl } from '../../utils/uploadUrl';

const BRAND = '#25D366';
const BRAND_DARK = '#128C7E';

function timeAgo(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return 'agora';
  if (s < 3600) return `${Math.floor(s / 60)}min`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  return d.toLocaleDateString('pt-BR');
}

// Card no PlayerDashboard: agrupa noticias dos times onde o jogador participa.
// Cada time vira uma "faixa" com nome+logo+ate 2 noticias recentes.
// Some se player nao joga em nenhum time.
export default function MyTeamsNewsCard() {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/community/players/me/team-news')
      .then(r => setTeams(r.data?.teams || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{ background: '#fff', borderRadius: 16, padding: 16, marginBottom: 16 }}>
      <Skeleton active paragraph={{ rows: 2 }} />
    </div>
  );
  if (teams.length === 0) return null;

  return (
    <Card style={{ borderRadius: 16, marginBottom: 16 }}
      title={<><NotificationOutlined /> Notícias dos meus times</>}>
      {teams.map(t => (
        <div key={t.team_id} style={{
          borderTop: '1px solid #f0f0f0', paddingTop: 12, marginTop: 12,
        }}>
          <a href={t.team_slug ? `/time/${t.team_slug}` : undefined}
             style={{
               display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10,
               textDecoration: 'none', color: 'inherit',
               cursor: t.team_slug ? 'pointer' : 'default',
             }}>
            <Avatar size={32} src={absoluteUploadUrl(t.logo_url)}>
              {t.team_name?.[0]}
            </Avatar>
            <div style={{ fontWeight: 700, color: BRAND_DARK }}>{t.team_name}</div>
          </a>
          {t.news.slice(0, 2).map(n => (
            <div key={n.id} style={{
              padding: '8px 10px', background: '#f9fafb', borderRadius: 10,
              marginBottom: 6, borderLeft: `3px solid ${BRAND}`,
            }}>
              <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 4 }}>
                {n.author_name} · {timeAgo(n.created_at)}
              </div>
              <div style={{ fontSize: 13, color: '#333', whiteSpace: 'pre-wrap' }}>
                {n.text.length > 220 ? n.text.slice(0, 220) + '...' : n.text}
              </div>
            </div>
          ))}
          {t.news.length > 2 && (
            <Tag color="green" style={{ marginTop: 4 }}>+{t.news.length - 2} mais</Tag>
          )}
        </div>
      ))}
    </Card>
  );
}
